<style src="./QuoteItemMessage.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="quote-item-message right-panel-box" v-click-outside="closePanel">
    <div class="chat-box" ref="chatBoxScroll">
      <div class="empty-box" v-if="messages.length === 0">
        <icon-empty />
        <span>Não há mensagens</span>
      </div>

      <div
        class="chat-message"
        v-if="messages.length > 0"
        v-for="message, idx in messages">

        <div
          class="message-container"
          :class="{ 'from-left': !amIHere(message), 'from-right': amIHere(message) }">

          <span class="user">{{ message.user.username }}:</span>
          <span class="message-content">{{ message.message }}</span>
        </div>
      </div>
    </div>
    <div class="chat-form">
      <form v-on:submit.stop.prevent="addNew">
        <textarea
          v-shortkey="['enter']"
          @shortkey="addNew"
          v-model="form.textMessage"
          placeholder="Escreva a mensagem aqui..."
          class="text-area" />

        <div class="command-panel">
          <button class="btn-small-success button-send">Enviar</button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { Textbox } from '@/components/primitives'
import { IconCheck, IconClose, IconEmpty } from '@/components/primitives/icons'
import NewReview from '@/brain/item-association/NewReview'
import ReadReview from '@/brain/item-association/ReadReview'

export default {
  name: 'QuoteItemMessage',
  components: {
    Textbox,
    IconCheck,
    IconClose,
    IconEmpty
  },
  data () {
    return {
      messages: [],
      form: {
        textMessage: ''
      }
    }
  },
  mounted () {
    this.readMessages()
  },
  // sockets: {
  //   'chat-quote-review' (pMsg) {
  //     const formattedMessage = {
  //       message: pMsg.message,
  //       quoteId: pMsg.quoteId,
  //       user: {
  //         username: pMsg.username
  //       }
  //     }
  //     this.messages.push(formattedMessage)
  //     this.form.textMessage = ''
  //     this.$nextTick(() => {
  //       this.autoScroll()
  //     })
  //   }
  // },
  methods: {
    async addNew () {
      await NewReview(this.$socket, { message: this.form.textMessage })
      this.readMessages()
    },
    closePanel () {
      this.$emit('cancel')
    },
    cancel (e) {
      e.stopPropagation()
      this.closePanel()
    },
    readMessages () {
      ReadReview()
        .then((messages) => {
          this.messages = messages
        })
    },
    amIHere ({ user = null }) {
      return user.username === this.$store.getters['Login/GET_USERNAME']
    },
    autoScroll () {
      this.$refs.chatBoxScroll.scrollTo(0, this.$refs.chatBoxScroll.scrollHeight)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/right-panel/quote-item-message/QuoteItemMessage.vue